module.exports = __webpack_public_path__ + "img/carrygo-support.dbb565c7.jpg";